import React from 'react';
import Avatar from '@atlaskit/avatar';
import TeamAvatar from '@atlaskit/teams-avatar';
import { isTeamMention } from '../../types';
export var MentionAvatar = function MentionAvatar(_ref) {
  var mention = _ref.mention,
    selected = _ref.selected;
  var avatarUrl = mention.avatarUrl,
    presence = mention.presence;
  var borderColor = selected ? "var(--ds-border, #0B120E24)" : undefined;
  var _ref2 = presence || {},
    status = _ref2.status;
  if (isTeamMention(mention)) {
    return /*#__PURE__*/React.createElement(TeamAvatar, {
      src: avatarUrl,
      size: "medium",
      borderColor: borderColor
    });
  }
  return /*#__PURE__*/React.createElement(Avatar, {
    src: avatarUrl,
    size: "medium",
    presence: status,
    borderColor: borderColor
  });
};